module.exports = __webpack_public_path__ + "static/media/landingPageVideo2.4d8b6123.png";